export const UNKNOWN_UPGRADE_CHANNEL_LABEL = 'Undefined';

// GA and an unreported/unrecognised channel are both calm: neither is something to act on.
const NEUTRAL_UPGRADE_CHANNEL_APPEARANCE = 'secondary';

// The channel reported by the appliance is the *installed* one, so a machine can legitimately
// report a pre-release channel after its enrollment was revoked, until it installs a GA version.
// GA stays neutral; every pre-release channel is given a distinct, louder appearance.
const UPGRADE_CHANNELS = {
	ga: { label: 'Stable', appearance: NEUTRAL_UPGRADE_CHANNEL_APPEARANCE },
	rc: { label: 'Preview', appearance: 'warning' },
	beta: { label: 'Beta', appearance: 'warning' },
	alpha: { label: 'Alpha', appearance: 'danger' },
};

const findUpgradeChannel = (currentUpgradeChannel) => {
	if (typeof currentUpgradeChannel !== 'string') {
		return null;
	}

	return UPGRADE_CHANNELS[currentUpgradeChannel.trim().toLowerCase()] || null;
};

export const getUpgradeChannelLabel = (currentUpgradeChannel) => {
	const channel = findUpgradeChannel(currentUpgradeChannel);

	if (channel) {
		return channel.label;
	}

	// An unrecognised channel is rendered verbatim rather than hidden, so a channel added on the
	// backend still shows something meaningful without a frontend release.
	return typeof currentUpgradeChannel === 'string' && currentUpgradeChannel.trim()
		? currentUpgradeChannel.trim()
		: UNKNOWN_UPGRADE_CHANNEL_LABEL;
};

export const getUpgradeChannelAppearance = (currentUpgradeChannel) => {
	const channel = findUpgradeChannel(currentUpgradeChannel);

	return channel ? channel.appearance : NEUTRAL_UPGRADE_CHANNEL_APPEARANCE;
};
